import React from 'react';
import qp from 'query-parse';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ActionsCard from '../components/common/filter';
import Pagination from '../components/common/pagination';
import * as requestActionCreators from '../redux/modules/request';

const getDate = new Date();

class BaseRequestsPaginationPage extends React.Component {
  constructor(props) {
    super(props);

    this.onFilterChange = this.onFilterChange.bind(this);
    this.onPageChanged = this.onPageChanged.bind(this);
    this.fetchRequests = this.fetchRequests.bind(this);

    this.state = {
      month: getDate.getMonth() + 1,
      year: getDate.getFullYear(),
      page: 1,
      requestStatus: 'pending',
    };
  }

  componentWillMount() {
    if (this.props.location.search) {
      const currentQuery = qp.toObject(this.props.location.search.substring(1));

      this.setState({
        month: currentQuery.month ? currentQuery.month : 0,
        year: currentQuery.year ? currentQuery.year : 0,
        requestStatus: currentQuery.requestStatus
          ? currentQuery.requestStatus
          : 'all',
        page: this.props.match.params.page,
      }, () => {
        this.fetchRequests();
      });
    } else {
      this.setState({ page: this.props.match.params.page || 1 },
        this.fetchRequests);
    }
  }

  onFilterChange(month, year, requestStatus) {
    this.setState({
      month, year, requestStatus, page: 1,
    }, () => {
      this.fetchRequests();
    });
  }

  onPageChanged(page) {
    this.setState({ page }, () => {
      this.fetchRequests();
    });
  }

  fetchRequests() {
    const {
      month, year, requestStatus, page,
    } = this.state;
    let filter = month > 0
      ? {
        month,
        year: (year > 0 ? year : undefined),
      }
      : (year > 0 ? { year } : undefined);

    filter = { ...filter, requestStatus, page };
    this.props.history.push(
      `/${this.props.requestType || 'requests'}/${page}${filter
        ? (`?${qp.toString(filter)}`)
        : ''}`);
    this.props.changeFilter(filter);
  }

  render() {
    return (
      <div className="row">
        <ActionsCard
          filterOptionValue={this.props.filterOptionValue}
          onChange={this.onFilterChange}
          filterValue={{ ...this.state }}
          actions={this.props.actions}
          showStatus
        />
        <div className="row">
          {this.props.children}
        </div>
        <Pagination
          match={this.props.match}
          onPageChanged={this.onPageChanged}
          pageCount={this.props.pageCount}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  pageCount: state.request.pageCount,
});

const mapDispatchToProps = dispatch => bindActionCreators(requestActionCreators,
  dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BaseRequestsPaginationPage));



// WEBPACK FOOTER //
// ./src/pages/BaseRequestsPaginationPage.js